import { render } from "./SelectedLocationToAttach.vue?vue&type=template&id=19bbe0a8&scoped=true&ts=true"
import script from "./SelectedLocationToAttach.vue?vue&type=script&lang=ts"
export * from "./SelectedLocationToAttach.vue?vue&type=script&lang=ts"

import "./SelectedLocationToAttach.vue?vue&type=style&index=0&id=19bbe0a8&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bbe0a8"]])

export default __exports__